import { useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import Auth from '../../../services/Auth';
import useSetUser from '../../../hooks/useSetUser';
import { GoogleTagManager } from '../../../helpers';

const UsePar = () => {
  const [loading, setLoading] = useState(true);
  const isClient = typeof window !== 'undefined';
  const setUser = useSetUser();

  const errorMapping = {
    DP01: {
      page: '/error/no-data/imsi-incorrecto',
      pagename: 'Error no data - Imsi incorrecto',
    },
    DP02: {
      page: '/error/no-data/customer-not-found',
      pagename: 'Error no data - Customer not found',
    },
    DP03: {
      page: '/error/no-data/error-conexion',
      pagename: 'Error no data - Conexion',
    },
  };

  const sendAsyncTagManager = async () =>
    GoogleTagManager.tagInteractiveEvent({
      eventCategory: 'Redirección MiWOM',
      eventAction: 'Usuario Redireccionado',
      eventTag: 'Par con Logeo exitoso',
    });

  useEffect(() => {
    const [, par] = window.location.href.split('?par=');
    if (isClient && par) {
      Auth.autoProcess(par)
        .then(async res => {
          setUser(res[0]);
          setLoading(false);
          sendAsyncTagManager();
        })
        .catch(e => {
          const { status = '', data = {} } = e || {};
          const { code = '' } = data || {};

          if (code && errorMapping[code]) {
            const { page, pagename } = errorMapping[code];
            GoogleTagManager.pushToDataLayer({
              event: 'pagina-virtual',
              page,
              pagename,
            });
          }

          GoogleTagManager.tagInteractiveEvent({
            eventCategory: 'Redirección MiWOM',
            eventAction: `Usuario Redireccionado - ${status}`,
            eventTag: 'Par con Logeo Fallido',
          });
          setUser(null);
          navigate('/error/no-data');
        });
    } else {
      setLoading(false);
    }
  }, []);

  return !loading;
};

export default UsePar;
